import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { AirSavedCardModel } from "./model";

type AirSavedCard = AirSavedCardModel[];

const initialAppState: AirSavedCard = [];

const airSavedCardSlice = createSlice({
  name: "airSavedCards",
  initialState: initialAppState,
  reducers: {
    setSavedCardsAction: (_, action: PayloadAction<AirSavedCardModel[]>) => {
      return action.payload;
    },
    prependSavedCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: AirSavedCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    appendSavedCardsAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: AirSavedCardModel[]; unique?: boolean }>
    ) => {
      if (unique) {
        const referencesSet = new Set<string>();
        state.forEach((item) => {
          if (item.reference) {
            referencesSet.add(item.reference);
          }
        });

        data.forEach((item) => {
          if (item.reference && !referencesSet.has(item.reference)) {
            state.push(item);
          }
        });
        return state;
      }
      return state.concat(data);
    },
    removeSavedCardAction: (state, action: PayloadAction<AirSavedCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSavedCardAction: (state, action: PayloadAction<AirSavedCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const airSavedCardBaseSelector = createBaseSelector(airSavedCardSlice);

registerSlice([airSavedCardSlice]);

export const airSavedCardStore = {
  actions: airSavedCardSlice.actions,
  selectors: {
    savedCards: createSelector(airSavedCardBaseSelector, (s) => s),
  },
};
